module.exports = __webpack_public_path__ + "static/media/P04.a5d2563c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panel_strobe/P04.png
// module id = 194
// module chunks = 0